exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".participantsList .styledTable td:last-child img{width:20px;height:20px}", "", {"version":3,"sources":["C:/projects/Infrastil/evm/evm-frontend-react/src/pages/Event/EventDetail/ParticipantsList/ParticipantsList.scss"],"names":[],"mappings":"AAAA,iDACE,WAAY,AACZ,WAAa,CAAE","file":"ParticipantsList.scss","sourcesContent":[".participantsList .styledTable td:last-child img {\n  width: 20px;\n  height: 20px; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":false,"sourceMap":true,"minimize":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./src/pages/Event/EventDetail/ParticipantsList/ParticipantsList.scss
// module id = 764
// module chunks = 0